import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

function HeaderLinks({ canonicalUrl, languageHreflang }) {
  return (
    <Helmet>
      {canonicalUrl && <link href={canonicalUrl} rel="canonical" />}
      {languageHreflang.length > 0 &&
        languageHreflang.map(({ href, hreflang }) => (
          <link href={href} hrefLang={hreflang} key={hreflang} rel="alternate" />
        ))}
    </Helmet>
  );
}

HeaderLinks.propTypes = {
  canonicalUrl: PropTypes.string,
  languageHreflang: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      hreflang: PropTypes.string.isRequired,
    }),
  ),
};

HeaderLinks.defaultProps = {
  canonicalUrl: '',
  languageHreflang: [],
};

// Module Exports
export { HeaderLinks };
